import { HeartFillIcon, HeartIcon } from '@svgs'
import clsx from 'clsx'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import CompareButton from 'src/components/elements/compare/CompareButton'
import { useGetUserQuery } from 'src/redux/api'

interface IInteractionButtons {
  isNew?: boolean
  isAuction?: boolean
  isFavorites?: boolean
  setIsFavorites: (value: boolean) => void
  // When set, a compare toggle ("⇄") is rendered next to the heart.
  propertyId?: string
  // Listing owner — the heart hides on the user's own listings, matching the
  // map grid and the announcement page.
  ownerId?: string
}

const InteractionButtons: FC<IInteractionButtons> = ({
  isNew,
  isAuction,
  setIsFavorites,
  isFavorites,
  propertyId,
  ownerId,
}) => {
  const { t } = useTranslation()
  const { data: user } = useGetUserQuery(undefined)
  const isOwn = !!user && !!ownerId && user.id === ownerId

  return (
    <div className="flex gap-2 justify-between items-start w-full">
      {(isNew || isAuction) && (
        <div className="flex gap-2">
          {isNew && (
            <span className="px-2.5 py-2 text-xs text-center text-white bg-danger-strong rounded-2xl">
              {t('property.new')}
            </span>
          )}
          {isAuction && (
            <span className="px-2.5 py-2 text-xs text-center text-white bg-success-strong rounded-2xl">
              {t('property.auction')}
            </span>
          )}
        </div>
      )}
      <div className="ml-auto flex items-center justify-end gap-2">
        {propertyId && <CompareButton propertyId={propertyId} />}
        {/* The heart is the single favourite control — a separate "remove"
            bin button was a confusing duplicate (owner feedback C2). */}
        {!isOwn && (
          <button
            onClick={() => setIsFavorites(!isFavorites)}
            aria-label={t('favorite.button')}
            className={clsx(
              'flex justify-center items-center w-11 h-11 md:w-9 md:h-9 rounded-full shadow-sm pointer-events-auto transition-colors duration-200',
              isFavorites
                ? 'bg-danger-strong hover:bg-danger-strong'
                : 'bg-surface hover:bg-brand-soft',
            )}
          >
            <span
              className={clsx(
                'icon-button w-[1.125rem] h-[1.125rem]',
                isFavorites ? 'fill-white' : 'fill-danger-strong',
              )}
            >
              {isFavorites ? <HeartFillIcon /> : <HeartIcon />}
            </span>
          </button>
        )}
      </div>
    </div>
  )
}

export default InteractionButtons
